import React, { Component } from 'react'
import cn from 'classnames'

import env from 'env'

import Button from 'client/shared/blocks/button'
import Linka from 'client/shared/blocks/linka'

import SVGInline from 'react-svg-inline'
import ExpandIcon from 'client/shared/icons/expand.svg'

import './expandable-bubbles-list.styl'
import { withI18n, withI18nProps } from '@lingui/react'

const ONE_LINE_HEIGHT = 44

export type NavItem = {
  id: string
  path: string
  title: string
}

type Props = {
  items: NavItem[]
  shouldHide?: boolean
} & withI18nProps

type State = {
  isExpanded: boolean
  width: number | null | undefined
}

class _ExpandableBubblesList extends Component<Props, State> {
  static defaultProps = {
    shouldHide: false,
  }

  state = { isExpanded: !this.props.shouldHide, width: null }

  wrapperRef: { current: null | HTMLDivElement } = React.createRef()

  componentDidMount(): void {
    this.saveWidth()
    this.addExpandButtonIfNeed()
    window.addEventListener('resize', this.addExpandButtonIfNeed)
  }

  componentWillUnmount(): void {
    window.removeEventListener('resize', this.addExpandButtonIfNeed)
  }

  saveWidth = (): null | undefined => {
    if (env.isServer()) return null

    this.setState({ width: window.innerWidth })
  }

  addExpandButtonIfNeed = (): null | undefined => {
    const { current: wrapper } = this.wrapperRef

    if (!wrapper || (env.isClient() && window.innerWidth === this.state.width))
      return null
    this.setState({ width: window.innerWidth })

    const height = wrapper.getBoundingClientRect().height
    if (!this.state.isExpanded) return null

    this.setState({ isExpanded: height <= ONE_LINE_HEIGHT * 2 })
  }

  expandHandle = (): void => {
    this.setState({ isExpanded: true })
  }

  render(): JSX.Element | null {
    const { items, i18n } = this.props

    if (!items || items.length === 0) return null

    const className = cn('expandable-bubbles-list', {
      'expandable-bubbles-list_expanded': this.state.isExpanded,
    })

    return (
      <div className={className} ref={this.wrapperRef}>
        <ul className="expandable-bubbles-list__items">
          {items.map(item => (
            <li className="expandable-bubbles-list__item" key={item.id}>
              <Linka
                className="expandable-bubbles-list__item-link"
                path={item.path}
              >
                {item.title}
              </Linka>
            </li>
          ))}
        </ul>
        <div className="expandable-bubbles-list__button-wrapper">
          <Button
            aria-label={i18n.t`book.more`}
            className="expandable-bubbles-list__button"
            onClick={this.expandHandle}
            kind="icon"
          >
            <SVGInline svg={ExpandIcon} />
          </Button>
        </div>
      </div>
    )
  }
}

export const ExpandableBubblesList = withI18n({ update: true })(
  _ExpandableBubblesList,
)
